export const useIframe = (parentDomain = "https://mbn-marathon.imweb.me") => {
  const setIframeHeight = (height) => {
    window.parent.postMessage(
      {
        type: "setIframeHeight",
        height: height,
      },
      parentDomain
    );
  };

  const setMoveUrl = (url) => {
    window.parent.postMessage(
      {
        type: "moveUrl",
        url: url,
      },
      parentDomain
    );
  };

  return { setIframeHeight, setMoveUrl };
};
